/**
 * Пустой/невалидный ввод (в т.ч. 0) → min; иначе значение с верхней границей max.
 * Нижний clamp для непустых значений не применяется, чтобы не мешать набору числа по цифрам.
 */
export const normalizeMiniCalculatorFieldInput = (
  value: number | string | undefined,
  min: number,
  max: number,
): number => {
  if (value === undefined || value === '') {
    return min;
  }

  const n = typeof value === 'string' ? Number(String(value).replace(/\s/g, '')) : value;

  if (!Number.isFinite(n) || n === 0) {
    return min;
  }

  if (n > max) {
    return max;
  }

  return n;
};
